import React, { useState } from 'react';

export default function Iletisim() {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ ad: '', tel: '', email: '', hizmet: '', mesaj: '' });

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = e => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <>
      <div className="page-hero">
        <div className="page-hero-content">
          <div className="page-hero-tag">İletişim</div>
          <h1>Projeniz için<br /><em>Birlikte Çalışalım</em></h1>
        </div>
      </div>

      <section className="section">
        <div className="contact-page-grid">

          {/* SOL: BİLGİLER */}
          <div>
            <div className="section-tag">Bize Ulaşın</div>
            <div className="section-title contact-title">İletişim Bilgileri</div>
            <p className="contact-desc">Sorularınız veya proje talepleriniz için aşağıdaki kanallardan bize ulaşabilirsiniz. Uzman ekibimiz en kısa sürede dönüş yapar.</p>

            <div className="contact-detail">
              <div className="contact-row">
                <div className="contact-icon">📍</div>
                <div>
                  <h5>Adres</h5>
                  <p>Hacıaliler, Serik Cd. 110 A, 07112 Aksu<br />Antalya, Türkiye</p>
                </div>
              </div>
              <div className="contact-row">
                <div className="contact-icon">📞</div>
                <div>
                  <h5>Telefon</h5>
                  <p>+90 533 264 89 52</p>
                </div>
              </div>

              <div className="contact-row">
                <div className="contact-icon">🕐</div>
                <div>
                  <h5>Çalışma Saatleri</h5>
                  <p>Pazartesi – Cuma: 08:00 – 18:00<br />Cumartesi: 09:00 – 14:00</p>
                </div>
              </div>
            </div>

            {/* HARİTA YERİ */}
            <a href="https://maps.app.goo.gl/xz6Azm8YzikSbv1q6" target="_blank" rel="noopener noreferrer" className="contact-map" style={{textDecoration:'none', display:'flex', alignItems:'center', justifyContent:'center', gap:'12px'}}>
              <span>📍</span>
              <span style={{color:'var(--cream)', fontSize:'14px', letterSpacing:'1px'}}>Haritada Görüntüle</span>
            </a>

            {/* SOSYAL */}
            <div className="social-links">
              <a href="https://www.instagram.com/wooddy.co/" target="_blank" rel="noopener noreferrer" className="social-link" title="Instagram">
                <i className="fa-brands fa-instagram" />
              </a>
              <a href="https://www.facebook.com/wooddy.co?mibextid=ZbWKwL&utm_source=ig&utm_medium=social&utm_content=link_in_bio" target="_blank" rel="noopener noreferrer" className="social-link" title="Facebook">
                <i className="fa-brands fa-facebook-f" />
              </a>
            </div>
          </div>

          {/* SAĞ: FORM */}
          <div>
            <div className="section-tag">Teklif Talebi</div>
            <div className="section-title contact-title">Bize Yazın</div>

            {sent ? (
              <div style={{
                marginTop:'32px', padding:'48px', background:'var(--cream)',
                textAlign:'center', borderLeft:'4px solid var(--wood-light)'
              }}>
                <div style={{fontSize:'48px', marginBottom:'16px'}}>✅</div>
                <div style={{fontFamily:"'Playfair Display', serif", fontSize:'24px', color:'var(--wood-dark)', marginBottom:'12px'}}>
                  Mesajınız İletildi!
                </div>
                <p style={{color:'var(--text-muted)', fontSize:'15px', lineHeight:'1.8'}}>
                  En kısa sürede ekibimiz sizinle iletişime geçecektir.
                </p>
                <button
                  className="btn-dark"
                  style={{marginTop:'24px'}}
                  onClick={() => { setSent(false); setForm({ ad:'', tel:'', email:'', hizmet:'', mesaj:'' }); }}
                >
                  Yeni Mesaj Gönder
                </button>
              </div>
            ) : (
              <div className="contact-form" style={{marginTop:'32px'}}>
                <div className="form-row">
                  <div className="form-group">
                    <label>Ad Soyad *</label>
                    <input name="ad" value={form.ad} onChange={handleChange} type="text" placeholder="Adınız Soyadınız" required />
                  </div>
                  <div className="form-group">
                    <label>Telefon *</label>
                    <input name="tel" value={form.tel} onChange={handleChange} type="text" placeholder="+90 5XX XXX XX XX" required />
                  </div>
                </div>
                <div className="form-group">
                  <label>E-posta *</label>
                  <input name="email" value={form.email} onChange={handleChange} type="email" placeholder="ornek@email.com" required />
                </div>
                <div className="form-group">
                  <label>Hizmet Türü</label>
                  <select name="hizmet" value={form.hizmet} onChange={handleChange}>
                    <option value="">Seçiniz...</option>
                    <option>Ham Kereste Üretimi</option>
                    <option>Özel Mobilya Tasarımı</option>
                    <option>İç Mekan Kaplama</option>
                    <option>Kapı &amp; Pencere Sistemleri</option>
                    <option>Ahşap Yapı Sistemleri</option>
                    <option>Restorasyon &amp; Onarım</option>
                    <option>Diğer</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Mesajınız *</label>
                  <textarea name="mesaj" value={form.mesaj} onChange={handleChange} rows="6" placeholder="Projenizi kısaca anlatın. Boyut, miktar, teslim tarihi gibi detayları paylaşabilirsiniz..." required />
                </div>
                <button className="form-submit" onClick={handleSubmit}>
                  Teklif Talep Et →
                </button>
                <p style={{fontSize:'12px', color:'var(--text-muted)', marginTop:'8px'}}>
                  * zorunlu alanlar · Bilgileriniz üçüncü kişilerle paylaşılmaz.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}